var _g, _defs;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgPlay = function SvgPlay(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1141_4822)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.314 68.0728L54.9803 33.0728C54.264 32.5874 53.34 32.5338 52.5746 32.9374C51.8116 33.3411 51.3333 34.1344 51.3333 35.0001V105C51.3333 105.866 51.8116 106.659 52.577 107.063C52.9176 107.245 53.2933 107.333 53.6666 107.333C54.1263 107.333 54.586 107.196 54.9803 106.927L106.314 71.9274C106.951 71.4934 107.333 70.7724 107.333 70.0001C107.333 69.2278 106.951 68.5068 106.314 68.0728Z",
    fill: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70 0C31.402 0 0 31.402 0 70C0 108.598 31.402 140 70 140C108.598 140 140 108.598 140 70C140 31.402 108.598 0 70 0ZM70 135.333C33.9757 135.333 4.66667 106.024 4.66667 70C4.66667 33.9757 33.9757 4.66667 70 4.66667C106.024 4.66667 135.333 33.9757 135.333 70C135.333 106.024 106.024 135.333 70 135.333Z",
    fill: "#C3C3C3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1141_4822"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 140,
    height: 140,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPlay, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/play.9f27c4d5.svg";
export { ForwardRef as ReactComponent };